/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extraction_Status_FailedInputs */

const en_extraction_status_failed = /** @type {(inputs: Extraction_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not read`)
};

/**
* | output |
* | --- |
* | "Not read" |
*
* @param {Extraction_Status_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const extraction_status_failed = /** @type {((inputs?: Extraction_Status_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extraction_Status_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_extraction_status_failed(inputs)
});